import { AccredibleAvatarComponentModule } from '@accredible-frontend-v2/components/avatar';
import { AccredibleChipListComponentModule } from '@accredible-frontend-v2/components/chip-list';
import { AccredibleContentFadeDirectiveModule } from '@accredible-frontend-v2/directives/content-fade';
import { AccredibleLocaleDatePipeModule } from '@accredible-frontend-v2/pipes/locale-date';
import { AccredibleTruncatePipeModule } from '@accredible-frontend-v2/pipes/truncate';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { UserCustomAttributesComponentModule } from '../../../../core/components/user-custom-attributes/user-custom-attributes.module';
import { SocialLinksComponentModule } from '../../../../shared/social-links/social-links.component.module';
import { ProfileListCardComponent } from './profile-list-card.component';

const MATERIAL_MODULES = [MatIconModule];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SocialLinksComponentModule,
    UserCustomAttributesComponentModule,
    AccredibleAvatarComponentModule,
    AccredibleChipListComponentModule,
    AccredibleLocaleDatePipeModule,
    AccredibleTruncatePipeModule,
    AccredibleContentFadeDirectiveModule,
    TranslocoModule,
    ...MATERIAL_MODULES,
  ],
  exports: [ProfileListCardComponent],
  declarations: [ProfileListCardComponent],
})
export class ProfileListCardModule {}
